// extracted by mini-css-extract-plugin
var _1 = "ControlBarAddOrSharePopOver-module__animateUploadProgressBarWidth--SWXuR";
var _2 = "ControlBarAddOrSharePopOver-module__animatedBackground--F9GiV";
var _3 = "ControlBarAddOrSharePopOver-module__arrow--YKkuq";
var _4 = "ControlBarAddOrSharePopOver-module__container--Yi3d3";
var _5 = "ControlBarAddOrSharePopOver-module__input--MUciy";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "arrow", _4 as "container", _5 as "input" }
